import axios from "axios";
import { showPersistentToast } from "../utils/persistentToast";
const api = axios.create({
  baseURL: "",
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      showPersistentToast('Your session has timed out. You have been logged out.', {
        position: "top-right",
        autoClose: false,
        closeOnClick: true,
        draggable: false,
        pauseOnHover: true,
        closeButton: true,
      });

      window.location.href = "/";
    }
    const method = error.config?.method?.toUpperCase();
    const rawUrl = error.config?.url;
    if (method && rawUrl) {
      // Strip query params and MongoDB ObjectIds (24-char hex) to normalize
      // URLs for consistent Rollbar grouping (e.g. v0/chat-session/:id → v0/chat-session)
      const endpoint = rawUrl
        .split('?')[0]
        .split('/')
        .filter((s) => !/^[a-f0-9]{24}$/.test(s))
        .join('/');
      const status = error.response?.status;
      error.message = status
        ? `${method} ${endpoint} failed with status ${status}`
        : `${method} ${endpoint} failed: ${error.message}`;
    }

    return Promise.reject(error);
  }
);

// No interceptor: a request nothing in the UI awaits must not force a logout
// because it came back 401.
export const supplementApi = axios.create({
  baseURL: "",
});

export default api;
